@if (prescriptionForm) {
  <td tuiTd>
    {{ prescriptionForm.nom }}
  </td>
  <td tuiTd>
    {{ prescriptionForm.prenom }}
  </td>
  <td tuiTd>
    {{ prescriptionForm.nir }}
  </td>
  <td tuiTd>
    {{ prescriptionForm.telephone }}
  </td>
  <td tuiTd>
    {{ prescriptionForm.adresseLigne1 }}
    <br />
    {{ prescriptionForm.adresseLigne2 }}
    @if (prescriptionForm.adresseLigne2) {
      <br />
    }
    {{ prescriptionForm.adresseCodePostal }} {{ prescriptionForm.adresseVille }}
  </td>

  <td tuiTd>
    <tui-tag
      [class]="['tag', prescriptionForm.codeDActivite]"
      [hoverable]="false"
      [value]="prescriptionForm.type?.nom ?? prescriptionForm.typeSlug"
    />
    <br>
    @if(isInitiale()){
      <tui-tag
      [class]="['tag', 'initiale']"
      [hoverable]="false"
      value="INITIALE"
      />
    } 
  </td>
  <td tuiTd>
    {{ prescriptionForm.dateDePrescription | date: "dd/MM/yyyy" }}
  </td>
  <td tuiTd>
    {{ prescriptionForm.createdAt | date: "dd/MM/yyyy" }}
  </td>
  <td tuiTd>
    @if (prescriptionForm.user) {
      {{ prescriptionForm.user.nom }} {{ prescriptionForm.user.prenom }}
    } @else {
      {{ prescriptionForm.userId }}
    }
  </td>
  <td tuiTd>
    @if (prescriptionForm.medecin) {
      {{ prescriptionForm.medecin.nom }} {{ prescriptionForm.medecin.prenom }}
    } @else {
      {{ prescriptionForm.medecinId }}
    }
  </td>

  <td tuiTd>
    @if (hasRecapitulatif()) {
      <button
        size="s"
        tuiButton
        type="button"
        appearance="outline"
        (click)="showRecapitulatif(actions, prescriptionForm.id!)"
      >
        Récapitulatif
      </button>
    }
  </td>

  <td tuiTd>
    @if (prescriptionForm.pdf && prescriptionForm.id) {
      <button
        size="s"
        tuiButton
        type="button"
        appearance="outline"
        (click)="show(actions, prescriptionForm.id)"
      >
        Prévisualiser
      </button>
    }
  </td>
} @else {
  <td tuiTd>NOM______</td>

  <td tuiTd>Prénom______</td>

  <td tuiTd>000000000000000</td>

  <td tuiTd>06.07.08.09.10</td>

  <td tuiTd>XX XXX XXXXXXXXXXXXXX XXXXXX<br />00000 XXXXXXXX</td>

  <td tuiTd>XXX XXXXXXXX</td>

  <td tuiTd>00/00/0000</td>

  <td tuiTd>00/00/0000</td>

  <td tuiTd>NOM______ Prénom______</td>

  <td tuiTd>NOM______ Prénom______</td>

  <td tuiTd></td>

  <td tuiTd></td>
}

<ng-template #actions let-content="content">
  <a download size="s" tuiButton [href]="content"> Télécharger </a>
</ng-template>
